// @flow

import { useState, useEffect } from "react";
import * as React from "react";
import ReactRouterPropTypes from "react-router-prop-types";

import { translate } from "../IntlProviderWrapper";
import ConfirmationModal from "../ConfirmationModal";

type BlockActions = "PUSH" | "REPLACE" | "POP";

const LeavePageWarning = (props: {
    history: ReactRouterPropTypes.history,
    location: ReactRouterPropTypes.location,
    block_actions?: BlockActions[],
    title?: string,
    children?: React.Node,
}) => {
    const { children, history, location, title, block_actions = ["POP"] } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [history_pathname, setHistoryPathname] = useState(null);

    useEffect(() => {
        const unblock = history.block((prev_location, action) => {
            if (!block_actions.includes(action) || prev_location.pathname === location.pathname) {
                return true;
            }

            setHistoryPathname(prev_location.pathname);
            setShowWarning(true);

            return false;
        });

        return () => {
            unblock();
        };
    }, []);

    const handleClose = () => {
        setShowWarning(false);
    };

    const handleContinue = () => {
        history.replace(history_pathname);
        setShowWarning(false);
    };

    return (
        <ConfirmationModal
            title={title !== undefined ? title : translate("common.leave_page", "Leave page")}
            accept_label={translate("common.leave", "Leave")}
            cancel_label={translate("common.cancel", "Cancel")}
            dangerous={true}
            onAccept={handleContinue}
            onCancel={handleClose}
            show={show_warning}
        >
            {children !== undefined
                ? children
                : translate("common.leave_page_warning", "Are you sure you want to leave this page?")}
        </ConfirmationModal>
    );
};

export default LeavePageWarning;
